import './styles.scss'

import React from 'react'
import { connect } from 'kea'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

import naturalCompare from 'string-natural-compare'

import courseLogic from '~/scenes/course/show/logic'

const immutableSort = skills => [...skills].sort((a, b) => naturalCompare.caseInsensitive(a, b))
const immutableSortByTitle = skills => [...skills].sort((a, b) => naturalCompare.caseInsensitive(a.title, b.title))

const Subcategory = ({ id, url, title, tags }) => {
  return (
    <div key={id} className='subcategory-container'>
      <div className='subcategory' style={{ marginBottom: tags && tags.length > 0 ? '11px' : '0' }}>
        <img src='/assets/course/badge_icon.svg' width={24} height={24} className='badge-icon' alt='badge icon' />
        <a href={url} className='subcategory-link'>
          {title}
        </a>
        <img
          src='/assets/profile-cards/arrow_right_icon.svg'
          width={16}
          height={16}
          className='arrow-icon'
          alt='right arrow icon'
        />
      </div>
      <div>
        {immutableSortByTitle(tags).map(({ id, title, subtags }) => (
          <div key={id} className='subcategory-tags'>
            {title ? `${title}: ` : null}
            {immutableSort(subtags).join(', ')}
          </div>
        ))}
      </div>
    </div>
  )
}

const Skills = ({ skills }) => {
  return (
    <div className='skills-section'>
      <div className='skills-header-container'>
        <img
          src='/assets/course/suitcase_icon.svg'
          width={24}
          height={24}
          className='suitcase-icon'
          alt='suitcase icon'
        />
        <span className='skills-name'>{I18n.t('courses.show.skills')}</span>
      </div>
      <div className='subcategories-container'>
        {immutableSortByTitle(skills).map(subCategory => (
          <Subcategory key={subCategory.id} {...subCategory} />
        ))}
      </div>
    </div>
  )
}

export default connect({
  props: [courseLogic, ['course']]
})(({ course: { studentAges, studentLevels, durations, languages, skills } }) => (
  <div>
    <h2>{I18n.t('courses.show.general')}</h2>
    <Skills skills={skills} />
    <table className='strong-boxes'>
      <tbody>
        <tr>
          <th>
            <span>{I18n.t('courses.show.age_start')}</span>
          </th>
          <td>
            {studentAges.map(age => (
              <div key={age}>{age}</div>
            ))}
          </td>
        </tr>
        <tr>
          <th>
            <span>{I18n.t('courses.show.student_level')}</span>
          </th>
          <td>
            {studentLevels.map(level => (
              <div key={level}>{level}</div>
            ))}
          </td>
        </tr>
        <tr>
          <th>
            <span>{I18n.t('courses.show.duration')}</span>
          </th>
          <td>
            {durations.map(duration => (
              <div key={duration}>{duration}</div>
            ))}
          </td>
        </tr>
        <tr>
          <th>
            <span>{I18n.t('courses.show.languages')}</span>
          </th>
          <td>{languages}</td>
        </tr>
      </tbody>
    </table>
  </div>
))

Subcategory.propTypes = {
  id: PropTypes.string,
  url: PropTypes.string,
  title: PropTypes.string,
  tags: PropTypes.array
}

Skills.propTypes = {
  skills: PropTypes.array
}
